/* GlobifySIM - destinations, generated from the product feed (222 entries). */
window.GS_REGIONEN = [
  {
    "id": "europa",
    "de": "Europe",
    "en": "Europe"
  },
  {
    "id": "asien",
    "de": "Asia",
    "en": "Asia"
  },
  {
    "id": "naher_osten",
    "de": "Middle East",
    "en": "Middle East"
  },
  {
    "id": "afrika",
    "de": "Africa",
    "en": "Africa"
  },
  {
    "id": "nordamerika",
    "de": "North America",
    "en": "North America"
  },
  {
    "id": "lateinamerika",
    "de": "Latin America & Caribbean",
    "en": "Latin America & Caribbean"
  },
  {
    "id": "ozeanien",
    "de": "Oceania",
    "en": "Oceania"
  },
  {
    "id": "paket",
    "de": "Regional & worldwide",
    "en": "Regional & worldwide"
  }
];
window.GS_ZIELE = [
  {
    "id": "af",
    "iso": "AF",
    "de": "Afghanistan",
    "en": "Afghanistan",
    "region": "asien",
    "flagge": "🇦🇫",
    "beliebt": false,
    "slug": "afghanistan",
    "such": "Afghanistan Kabul AF",
    "handle": "af_package"
  },
  {
    "id": "ax",
    "iso": "AX",
    "de": "Åland",
    "en": "Aland Islands",
    "region": "europa",
    "flagge": "🇦🇽",
    "beliebt": false,
    "slug": "aland-islands",
    "such": "Aland Islands Alandinseln Aland AX",
    "handle": "ax_package"
  },
  {
    "id": "al",
    "iso": "AL",
    "de": "Albanien",
    "en": "Albania",
    "region": "europa",
    "flagge": "🇦🇱",
    "beliebt": false,
    "slug": "albania",
    "such": "Albania Tirana Ksamil Saranda AL",
    "handle": "al_package"
  },
  {
    "id": "dz",
    "iso": "DZ",
    "de": "Algerien",
    "en": "Algeria",
    "region": "afrika",
    "flagge": "🇩🇿",
    "beliebt": false,
    "slug": "algeria",
    "such": "Algeria Algier DZ",
    "handle": "dz_package"
  },
  {
    "id": "ad",
    "iso": "AD",
    "de": "Andorra",
    "en": "Andorra",
    "region": "europa",
    "flagge": "🇦🇩",
    "beliebt": false,
    "slug": "andorra",
    "such": "Andorra  AD",
    "handle": "ad_package"
  },
  {
    "id": "ao",
    "iso": "AO",
    "de": "Angola",
    "en": "Angola",
    "region": "afrika",
    "flagge": "🇦🇴",
    "beliebt": false,
    "slug": "angola",
    "such": "Angola Luanda AO",
    "handle": "ao_package"
  },
  {
    "id": "ai",
    "iso": "AI",
    "de": "Anguilla",
    "en": "Anguilla",
    "region": "lateinamerika",
    "flagge": "🇦🇮",
    "beliebt": false,
    "slug": "anguilla",
    "such": "Anguilla  AI",
    "handle": "ai_package"
  },
  {
    "id": "ag",
    "iso": "AG",
    "de": "Antigua und Barbuda",
    "en": "Antigua and Barbuda",
    "region": "lateinamerika",
    "flagge": "🇦🇬",
    "beliebt": false,
    "slug": "antigua-and-barbuda",
    "such": "Antigua and Barbuda  AG",
    "handle": "ag_package"
  },
  {
    "id": "ar",
    "iso": "AR",
    "de": "Argentinien",
    "en": "Argentina",
    "region": "lateinamerika",
    "flagge": "🇦🇷",
    "beliebt": false,
    "slug": "argentina",
    "such": "Argentina Buenos Aires Patagonien AR",
    "handle": "ar_package"
  },
  {
    "id": "am",
    "iso": "AM",
    "de": "Armenien",
    "en": "Armenia",
    "region": "asien",
    "flagge": "🇦🇲",
    "beliebt": false,
    "slug": "armenia",
    "such": "Armenia Eriwan Jerewan AM",
    "handle": "am_package"
  },
  {
    "id": "aw",
    "iso": "AW",
    "de": "Aruba",
    "en": "Aruba",
    "region": "lateinamerika",
    "flagge": "🇦🇼",
    "beliebt": false,
    "slug": "aruba",
    "such": "Aruba  AW",
    "handle": "aw_package"
  },
  {
    "id": "au",
    "iso": "AU",
    "de": "Australien",
    "en": "Australia",
    "region": "ozeanien",
    "flagge": "🇦🇺",
    "beliebt": true,
    "slug": "australia",
    "such": "Australia Sydney Melbourne Brisbane AU",
    "handle": "au_package"
  },
  {
    "id": "at",
    "iso": "AT",
    "de": "Österreich",
    "en": "Austria",
    "region": "europa",
    "flagge": "🇦🇹",
    "beliebt": true,
    "slug": "austria",
    "such": "Austria Wien Tirol Salzburg Oesterreich AT",
    "handle": "at_package"
  },
  {
    "id": "az",
    "iso": "AZ",
    "de": "Aserbaidschan",
    "en": "Azerbaijan",
    "region": "asien",
    "flagge": "🇦🇿",
    "beliebt": false,
    "slug": "azerbaijan",
    "such": "Azerbaijan Baku AZ",
    "handle": "az_package"
  },
  {
    "id": "bs",
    "iso": "BS",
    "de": "Bahamas",
    "en": "Bahamas",
    "region": "lateinamerika",
    "flagge": "🇧🇸",
    "beliebt": false,
    "slug": "bahamas",
    "such": "Bahamas Nassau BS",
    "handle": "bs_package"
  },
  {
    "id": "bh",
    "iso": "BH",
    "de": "Bahrain",
    "en": "Bahrain",
    "region": "naher_osten",
    "flagge": "🇧🇭",
    "beliebt": false,
    "slug": "bahrain",
    "such": "Bahrain Manama BH",
    "handle": "bh_package"
  },
  {
    "id": "bd",
    "iso": "BD",
    "de": "Bangladesch",
    "en": "Bangladesh",
    "region": "asien",
    "flagge": "🇧🇩",
    "beliebt": false,
    "slug": "bangladesh",
    "such": "Bangladesh Dhaka BD",
    "handle": "bd_package"
  },
  {
    "id": "bb",
    "iso": "BB",
    "de": "Barbados",
    "en": "Barbados",
    "region": "lateinamerika",
    "flagge": "🇧🇧",
    "beliebt": false,
    "slug": "barbados",
    "such": "Barbados Bridgetown BB",
    "handle": "bb_package"
  },
  {
    "id": "by",
    "iso": "BY",
    "de": "Belarus",
    "en": "Belarus",
    "region": "europa",
    "flagge": "🇧🇾",
    "beliebt": false,
    "slug": "belarus",
    "such": "Belarus Weißrussland Weissrussland Minsk BY",
    "handle": "by_package"
  },
  {
    "id": "be",
    "iso": "BE",
    "de": "Belgien",
    "en": "Belgium",
    "region": "europa",
    "flagge": "🇧🇪",
    "beliebt": false,
    "slug": "belgium",
    "such": "Belgium Brüssel Antwerpen Bruegge BE",
    "handle": "be_package"
  },
  {
    "id": "bz",
    "iso": "BZ",
    "de": "Belize",
    "en": "Belize",
    "region": "lateinamerika",
    "flagge": "🇧🇿",
    "beliebt": false,
    "slug": "belize",
    "such": "Belize  BZ",
    "handle": "bz_package"
  },
  {
    "id": "bj",
    "iso": "BJ",
    "de": "Benin",
    "en": "Benin",
    "region": "afrika",
    "flagge": "🇧🇯",
    "beliebt": false,
    "slug": "benin",
    "such": "Benin Cotonou BJ",
    "handle": "bj_package"
  },
  {
    "id": "bm",
    "iso": "BM",
    "de": "Bermuda",
    "en": "Bermuda",
    "region": "nordamerika",
    "flagge": "🇧🇲",
    "beliebt": false,
    "slug": "bermuda",
    "such": "Bermuda  BM",
    "handle": "bm_package"
  },
  {
    "id": "bt",
    "iso": "BT",
    "de": "Bhutan",
    "en": "Bhutan",
    "region": "asien",
    "flagge": "🇧🇹",
    "beliebt": false,
    "slug": "bhutan",
    "such": "Bhutan Thimphu BT",
    "handle": "bt_package"
  },
  {
    "id": "bo",
    "iso": "BO",
    "de": "Bolivien",
    "en": "Bolivia",
    "region": "lateinamerika",
    "flagge": "🇧🇴",
    "beliebt": false,
    "slug": "bolivia",
    "such": "Bolivia La Paz Uyuni BO",
    "handle": "bo_package"
  },
  {
    "id": "ba",
    "iso": "BA",
    "de": "Bosnien und Herzegowina",
    "en": "Bosnia and Herzegovina",
    "region": "europa",
    "flagge": "🇧🇦",
    "beliebt": false,
    "slug": "bosnia-and-herzegovina",
    "such": "Bosnia and Herzegovina Sarajevo Mostar BA",
    "handle": "ba_package"
  },
  {
    "id": "bw",
    "iso": "BW",
    "de": "Botsuana",
    "en": "Botswana",
    "region": "afrika",
    "flagge": "🇧🇼",
    "beliebt": false,
    "slug": "botswana",
    "such": "Botswana Gaborone Okavango BW",
    "handle": "bw_package"
  },
  {
    "id": "br",
    "iso": "BR",
    "de": "Brasilien",
    "en": "Brazil",
    "region": "lateinamerika",
    "flagge": "🇧🇷",
    "beliebt": true,
    "slug": "brazil",
    "such": "Brazil Rio de Janeiro Sao Paulo BR",
    "handle": "br_package"
  },
  {
    "id": "bn",
    "iso": "BN",
    "de": "Brunei",
    "en": "Brunei Darussalam",
    "region": "asien",
    "flagge": "🇧🇳",
    "beliebt": false,
    "slug": "brunei-darussalam",
    "such": "Brunei Darussalam Brunei Darussalam BN",
    "handle": "bn_package"
  },
  {
    "id": "bg",
    "iso": "BG",
    "de": "Bulgarien",
    "en": "Bulgaria",
    "region": "europa",
    "flagge": "🇧🇬",
    "beliebt": true,
    "slug": "bulgaria",
    "such": "Bulgaria Sofia Sonnenstrand Burgas Varna BG",
    "handle": "bg_package"
  },
  {
    "id": "bf",
    "iso": "BF",
    "de": "Burkina Faso",
    "en": "Burkina Faso",
    "region": "afrika",
    "flagge": "🇧🇫",
    "beliebt": false,
    "slug": "burkina-faso",
    "such": "Burkina Faso Ouagadougou BF",
    "handle": "bf_package"
  },
  {
    "id": "kh",
    "iso": "KH",
    "de": "Kambodscha",
    "en": "Cambodia",
    "region": "asien",
    "flagge": "🇰🇭",
    "beliebt": false,
    "slug": "cambodia",
    "such": "Cambodia Phnom Penh Siem Reap Angkor KH",
    "handle": "kh_package"
  },
  {
    "id": "cm",
    "iso": "CM",
    "de": "Kamerun",
    "en": "Cameroon",
    "region": "afrika",
    "flagge": "🇨🇲",
    "beliebt": false,
    "slug": "cameroon",
    "such": "Cameroon Duala Jaunde CM",
    "handle": "cm_package"
  },
  {
    "id": "ca",
    "iso": "CA",
    "de": "Kanada",
    "en": "Canada",
    "region": "nordamerika",
    "flagge": "🇨🇦",
    "beliebt": true,
    "slug": "canada",
    "such": "Canada Toronto Vancouver Montreal CA",
    "handle": "ca_package"
  },
  {
    "id": "cv",
    "iso": "CV",
    "de": "Kap Verde",
    "en": "Cape Verde",
    "region": "afrika",
    "flagge": "🇨🇻",
    "beliebt": true,
    "slug": "cape-verde",
    "such": "Cape Verde Kapverden Sal Boa Vista CV",
    "handle": "cv_package"
  },
  {
    "id": "ky",
    "iso": "KY",
    "de": "Kaimaninseln",
    "en": "Cayman Islands",
    "region": "lateinamerika",
    "flagge": "🇰🇾",
    "beliebt": false,
    "slug": "cayman-islands",
    "such": "Cayman Islands Cayman Islands Grand Cayman KY",
    "handle": "ky_package"
  },
  {
    "id": "cf",
    "iso": "CF",
    "de": "Zentralafrikanische Republik",
    "en": "Central African Republic",
    "region": "afrika",
    "flagge": "🇨🇫",
    "beliebt": false,
    "slug": "central-african-republic",
    "such": "Central African Republic Bangui CF",
    "handle": "cf_package"
  },
  {
    "id": "td",
    "iso": "TD",
    "de": "Tschad",
    "en": "Chad",
    "region": "afrika",
    "flagge": "🇹🇩",
    "beliebt": false,
    "slug": "chad",
    "such": "Chad N Djamena TD",
    "handle": "td_package"
  },
  {
    "id": "cl",
    "iso": "CL",
    "de": "Chile",
    "en": "Chile",
    "region": "lateinamerika",
    "flagge": "🇨🇱",
    "beliebt": false,
    "slug": "chile",
    "such": "Chile Santiago Atacama CL",
    "handle": "cl_package"
  },
  {
    "id": "cn",
    "iso": "CN",
    "de": "China",
    "en": "China",
    "region": "asien",
    "flagge": "🇨🇳",
    "beliebt": true,
    "slug": "china",
    "such": "China Peking Shanghai Festland CN",
    "handle": "cn_package"
  },
  {
    "id": "co",
    "iso": "CO",
    "de": "Kolumbien",
    "en": "Colombia",
    "region": "lateinamerika",
    "flagge": "🇨🇴",
    "beliebt": false,
    "slug": "colombia",
    "such": "Colombia Bogota Medellin Cartagena CO",
    "handle": "co_package"
  },
  {
    "id": "cr",
    "iso": "CR",
    "de": "Costa Rica",
    "en": "Costa Rica",
    "region": "lateinamerika",
    "flagge": "🇨🇷",
    "beliebt": false,
    "slug": "costa-rica",
    "such": "Costa Rica San Jose CR",
    "handle": "cr_package"
  },
  {
    "id": "ci",
    "iso": "CI",
    "de": "Elfenbeinküste",
    "en": "Cote d'Ivoire",
    "region": "afrika",
    "flagge": "🇨🇮",
    "beliebt": false,
    "slug": "cote-d-ivoire",
    "such": "Cote d'Ivoire Cote d Ivoire Abidjan CI",
    "handle": "ci_package"
  },
  {
    "id": "hr",
    "iso": "HR",
    "de": "Kroatien",
    "en": "Croatia",
    "region": "europa",
    "flagge": "🇭🇷",
    "beliebt": true,
    "slug": "croatia",
    "such": "Croatia Split Dubrovnik Istrien Zadar Pula HR",
    "handle": "hr_package"
  },
  {
    "id": "cw",
    "iso": "CW",
    "de": "Curaçao",
    "en": "Curaçao",
    "region": "lateinamerika",
    "flagge": "🇨🇼",
    "beliebt": false,
    "slug": "curacao",
    "such": "Curaçao Curacao Willemstad CW",
    "handle": "cw_package"
  },
  {
    "id": "cy",
    "iso": "CY",
    "de": "Zypern",
    "en": "Cyprus",
    "region": "europa",
    "flagge": "🇨🇾",
    "beliebt": true,
    "slug": "cyprus",
    "such": "Cyprus Larnaka Paphos Ayia Napa CY",
    "handle": "cy_package"
  },
  {
    "id": "cz",
    "iso": "CZ",
    "de": "Tschechien",
    "en": "Czech Republic",
    "region": "europa",
    "flagge": "🇨🇿",
    "beliebt": true,
    "slug": "czech-republic",
    "such": "Czech Republic Prag Tschechische Republik CZ",
    "handle": "cz_package"
  },
  {
    "id": "cd",
    "iso": "CD",
    "de": "Demokratische Republik Kongo",
    "en": "Democratic Republic of the Congo",
    "region": "afrika",
    "flagge": "🇨🇩",
    "beliebt": false,
    "slug": "democratic-republic-of-the-congo",
    "such": "Democratic Republic of the Congo Kinshasa CD",
    "handle": "cd_package"
  },
  {
    "id": "dk",
    "iso": "DK",
    "de": "Dänemark",
    "en": "Denmark",
    "region": "europa",
    "flagge": "🇩🇰",
    "beliebt": false,
    "slug": "denmark",
    "such": "Denmark Kopenhagen Daenemark DK",
    "handle": "dk_package"
  },
  {
    "id": "dm",
    "iso": "DM",
    "de": "Dominica",
    "en": "Dominica",
    "region": "lateinamerika",
    "flagge": "🇩🇲",
    "beliebt": false,
    "slug": "dominica",
    "such": "Dominica  DM",
    "handle": "dm_package"
  },
  {
    "id": "do",
    "iso": "DO",
    "de": "Dominikanische Republik",
    "en": "Dominican Republic",
    "region": "lateinamerika",
    "flagge": "🇩🇴",
    "beliebt": true,
    "slug": "dominican-republic",
    "such": "Dominican Republic Punta Cana Santo Domingo DO",
    "handle": "do_package"
  },
  {
    "id": "ec",
    "iso": "EC",
    "de": "Ecuador",
    "en": "Ecuador",
    "region": "lateinamerika",
    "flagge": "🇪🇨",
    "beliebt": false,
    "slug": "ecuador",
    "such": "Ecuador Quito Galapagos EC",
    "handle": "ec_package"
  },
  {
    "id": "eg",
    "iso": "EG",
    "de": "Ägypten",
    "en": "Egypt",
    "region": "afrika",
    "flagge": "🇪🇬",
    "beliebt": true,
    "slug": "egypt",
    "such": "Egypt Hurghada Kairo Sharm El Sheikh Aegypten Marsa Alam EG",
    "handle": "eg_package"
  },
  {
    "id": "sv",
    "iso": "SV",
    "de": "El Salvador",
    "en": "El Salvador",
    "region": "lateinamerika",
    "flagge": "🇸🇻",
    "beliebt": false,
    "slug": "el-salvador",
    "such": "El Salvador San Salvador SV",
    "handle": "sv_package"
  },
  {
    "id": "ee",
    "iso": "EE",
    "de": "Estland",
    "en": "Estonia",
    "region": "europa",
    "flagge": "🇪🇪",
    "beliebt": false,
    "slug": "estonia",
    "such": "Estonia Tallinn EE",
    "handle": "ee_package"
  },
  {
    "id": "sz",
    "iso": "SZ",
    "de": "Eswatini",
    "en": "Eswatini",
    "region": "afrika",
    "flagge": "🇸🇿",
    "beliebt": false,
    "slug": "eswatini",
    "such": "Eswatini Swasiland SZ",
    "handle": "sz_package"
  },
  {
    "id": "et",
    "iso": "ET",
    "de": "Äthiopien",
    "en": "Ethiopia",
    "region": "afrika",
    "flagge": "🇪🇹",
    "beliebt": false,
    "slug": "ethiopia",
    "such": "Ethiopia Addis Abeba Aethiopien ET",
    "handle": "et_package"
  },
  {
    "id": "fo",
    "iso": "FO",
    "de": "Färöer",
    "en": "Faroe Islands",
    "region": "europa",
    "flagge": "🇫🇴",
    "beliebt": false,
    "slug": "faroe-islands",
    "such": "Faroe Islands Faeroeer Torshavn FO",
    "handle": "fo_package"
  },
  {
    "id": "fj",
    "iso": "FJ",
    "de": "Fidschi",
    "en": "Fiji",
    "region": "ozeanien",
    "flagge": "🇫🇯",
    "beliebt": false,
    "slug": "fiji",
    "such": "Fiji Suva FJ",
    "handle": "fj_package"
  },
  {
    "id": "fi",
    "iso": "FI",
    "de": "Finnland",
    "en": "Finland",
    "region": "europa",
    "flagge": "🇫🇮",
    "beliebt": false,
    "slug": "finland",
    "such": "Finland Helsinki Lappland Rovaniemi FI",
    "handle": "fi_package"
  },
  {
    "id": "fr",
    "iso": "FR",
    "de": "Frankreich",
    "en": "France",
    "region": "europa",
    "flagge": "🇫🇷",
    "beliebt": true,
    "slug": "france",
    "such": "France Paris Nizza Korsika Provence FR",
    "handle": "fr_package"
  },
  {
    "id": "gf",
    "iso": "GF",
    "de": "Französisch-Guayana",
    "en": "French Guiana",
    "region": "lateinamerika",
    "flagge": "🇬🇫",
    "beliebt": false,
    "slug": "french-guiana",
    "such": "French Guiana Franzoesisch Guayana Cayenne GF",
    "handle": "gf_package"
  },
  {
    "id": "pf",
    "iso": "PF",
    "de": "Französisch-Polynesien",
    "en": "French Polynesia",
    "region": "ozeanien",
    "flagge": "🇵🇫",
    "beliebt": false,
    "slug": "french-polynesia",
    "such": "French Polynesia Tahiti Bora Bora Franzoesisch Polynesien PF",
    "handle": "pf_package"
  },
  {
    "id": "ga",
    "iso": "GA",
    "de": "Gabun",
    "en": "Gabon",
    "region": "afrika",
    "flagge": "🇬🇦",
    "beliebt": false,
    "slug": "gabon",
    "such": "Gabon Libreville GA",
    "handle": "ga_package"
  },
  {
    "id": "gm",
    "iso": "GM",
    "de": "Gambia",
    "en": "Gambia",
    "region": "afrika",
    "flagge": "🇬🇲",
    "beliebt": false,
    "slug": "gambia",
    "such": "Gambia Banjul GM",
    "handle": "gm_package"
  },
  {
    "id": "ge",
    "iso": "GE",
    "de": "Georgien",
    "en": "Georgia",
    "region": "europa",
    "flagge": "🇬🇪",
    "beliebt": false,
    "slug": "georgia",
    "such": "Georgia Tiflis Batumi GE",
    "handle": "ge_package"
  },
  {
    "id": "de",
    "iso": "DE",
    "de": "Deutschland",
    "en": "Germany",
    "region": "europa",
    "flagge": "🇩🇪",
    "beliebt": false,
    "slug": "germany",
    "such": "Germany Berlin München Hamburg DE",
    "handle": "de_package"
  },
  {
    "id": "gh",
    "iso": "GH",
    "de": "Ghana",
    "en": "Ghana",
    "region": "afrika",
    "flagge": "🇬🇭",
    "beliebt": false,
    "slug": "ghana",
    "such": "Ghana Accra GH",
    "handle": "gh_package"
  },
  {
    "id": "gi",
    "iso": "GI",
    "de": "Gibraltar",
    "en": "Gibraltar",
    "region": "europa",
    "flagge": "🇬🇮",
    "beliebt": false,
    "slug": "gibraltar",
    "such": "Gibraltar  GI",
    "handle": "gi_package"
  },
  {
    "id": "gr",
    "iso": "GR",
    "de": "Griechenland",
    "en": "Greece",
    "region": "europa",
    "flagge": "🇬🇷",
    "beliebt": true,
    "slug": "greece",
    "such": "Greece Kreta Rhodos Athen Korfu Kos Santorin GR",
    "handle": "gr_package"
  },
  {
    "id": "gl",
    "iso": "GL",
    "de": "Grönland",
    "en": "Greenland",
    "region": "nordamerika",
    "flagge": "🇬🇱",
    "beliebt": false,
    "slug": "greenland",
    "such": "Greenland Groenland Nuuk GL",
    "handle": "gl_package"
  },
  {
    "id": "gd",
    "iso": "GD",
    "de": "Grenada",
    "en": "Grenada",
    "region": "lateinamerika",
    "flagge": "🇬🇩",
    "beliebt": false,
    "slug": "grenada",
    "such": "Grenada  GD",
    "handle": "gd_package"
  },
  {
    "id": "gp",
    "iso": "GP",
    "de": "Guadeloupe",
    "en": "Guadeloupe",
    "region": "lateinamerika",
    "flagge": "🇬🇵",
    "beliebt": false,
    "slug": "guadeloupe",
    "such": "Guadeloupe  GP",
    "handle": "gp_package"
  },
  {
    "id": "gu",
    "iso": "GU",
    "de": "Guam",
    "en": "Guam",
    "region": "ozeanien",
    "flagge": "🇬🇺",
    "beliebt": false,
    "slug": "guam",
    "such": "Guam  GU",
    "handle": "gu_package"
  },
  {
    "id": "gt",
    "iso": "GT",
    "de": "Guatemala",
    "en": "Guatemala",
    "region": "lateinamerika",
    "flagge": "🇬🇹",
    "beliebt": false,
    "slug": "guatemala",
    "such": "Guatemala Antigua GT",
    "handle": "gt_package"
  },
  {
    "id": "gg",
    "iso": "GG",
    "de": "Guernsey",
    "en": "Guernsey",
    "region": "europa",
    "flagge": "🇬🇬",
    "beliebt": false,
    "slug": "guernsey",
    "such": "Guernsey  GG",
    "handle": "gg_package"
  },
  {
    "id": "gn",
    "iso": "GN",
    "de": "Guinea",
    "en": "Guinea",
    "region": "afrika",
    "flagge": "🇬🇳",
    "beliebt": false,
    "slug": "guinea",
    "such": "Guinea Conakry GN",
    "handle": "gn_package"
  },
  {
    "id": "gw",
    "iso": "GW",
    "de": "Guinea-Bissau",
    "en": "Guinea-Bissau",
    "region": "afrika",
    "flagge": "🇬🇼",
    "beliebt": false,
    "slug": "guinea-bissau",
    "such": "Guinea-Bissau  GW",
    "handle": "gw_package"
  },
  {
    "id": "gy",
    "iso": "GY",
    "de": "Guyana",
    "en": "Guyana",
    "region": "lateinamerika",
    "flagge": "🇬🇾",
    "beliebt": false,
    "slug": "guyana",
    "such": "Guyana Georgetown GY",
    "handle": "gy_package"
  },
  {
    "id": "ht",
    "iso": "HT",
    "de": "Haiti",
    "en": "Haiti",
    "region": "lateinamerika",
    "flagge": "🇭🇹",
    "beliebt": false,
    "slug": "haiti",
    "such": "Haiti Port au Prince HT",
    "handle": "ht_package"
  },
  {
    "id": "hn",
    "iso": "HN",
    "de": "Honduras",
    "en": "Honduras",
    "region": "lateinamerika",
    "flagge": "🇭🇳",
    "beliebt": false,
    "slug": "honduras",
    "such": "Honduras Roatan HN",
    "handle": "hn_package"
  },
  {
    "id": "hk",
    "iso": "HK",
    "de": "Hongkong",
    "en": "Hong Kong",
    "region": "asien",
    "flagge": "🇭🇰",
    "beliebt": false,
    "slug": "hong-kong",
    "such": "Hong Kong Hong Kong HK",
    "handle": "hk_package"
  },
  {
    "id": "hu",
    "iso": "HU",
    "de": "Ungarn",
    "en": "Hungary",
    "region": "europa",
    "flagge": "🇭🇺",
    "beliebt": false,
    "slug": "hungary",
    "such": "Hungary Budapest Balaton HU",
    "handle": "hu_package"
  },
  {
    "id": "is",
    "iso": "IS",
    "de": "Island",
    "en": "Iceland",
    "region": "europa",
    "flagge": "🇮🇸",
    "beliebt": true,
    "slug": "iceland",
    "such": "Iceland Reykjavik IS",
    "handle": "is_package"
  },
  {
    "id": "in",
    "iso": "IN",
    "de": "Indien",
    "en": "India",
    "region": "asien",
    "flagge": "🇮🇳",
    "beliebt": true,
    "slug": "india",
    "such": "India Delhi Mumbai Goa Kerala IN",
    "handle": "in_package"
  },
  {
    "id": "id",
    "iso": "ID",
    "de": "Indonesien",
    "en": "Indonesia",
    "region": "asien",
    "flagge": "🇮🇩",
    "beliebt": true,
    "slug": "indonesia",
    "such": "Indonesia Bali Jakarta Lombok Java ID",
    "handle": "id_package"
  },
  {
    "id": "iq",
    "iso": "IQ",
    "de": "Irak",
    "en": "Iraq",
    "region": "naher_osten",
    "flagge": "🇮🇶",
    "beliebt": false,
    "slug": "iraq",
    "such": "Iraq Bagdad Erbil IQ",
    "handle": "iq_package"
  },
  {
    "id": "ie",
    "iso": "IE",
    "de": "Irland",
    "en": "Ireland",
    "region": "europa",
    "flagge": "🇮🇪",
    "beliebt": false,
    "slug": "ireland",
    "such": "Ireland Dublin IE",
    "handle": "ie_package"
  },
  {
    "id": "im",
    "iso": "IM",
    "de": "Isle of Man",
    "en": "Isle of Man",
    "region": "europa",
    "flagge": "🇮🇲",
    "beliebt": false,
    "slug": "isle-of-man",
    "such": "Isle of Man  IM",
    "handle": "im_package"
  },
  {
    "id": "il",
    "iso": "IL",
    "de": "Israel",
    "en": "Israel",
    "region": "naher_osten",
    "flagge": "🇮🇱",
    "beliebt": false,
    "slug": "israel",
    "such": "Israel Tel Aviv Jerusalem IL",
    "handle": "il_package"
  },
  {
    "id": "it",
    "iso": "IT",
    "de": "Italien",
    "en": "Italy",
    "region": "europa",
    "flagge": "🇮🇹",
    "beliebt": true,
    "slug": "italy",
    "such": "Italy Rom Mailand Sizilien Gardasee Venedig Toskana IT",
    "handle": "it_package"
  },
  {
    "id": "jm",
    "iso": "JM",
    "de": "Jamaika",
    "en": "Jamaica",
    "region": "lateinamerika",
    "flagge": "🇯🇲",
    "beliebt": false,
    "slug": "jamaica",
    "such": "Jamaica Kingston Montego Bay JM",
    "handle": "jm_package"
  },
  {
    "id": "jp",
    "iso": "JP",
    "de": "Japan",
    "en": "Japan",
    "region": "asien",
    "flagge": "🇯🇵",
    "beliebt": true,
    "slug": "japan",
    "such": "Japan Tokio Osaka Kyoto JP",
    "handle": "jp_package"
  },
  {
    "id": "je",
    "iso": "JE",
    "de": "Jersey",
    "en": "Jersey",
    "region": "europa",
    "flagge": "🇯🇪",
    "beliebt": false,
    "slug": "jersey",
    "such": "Jersey  JE",
    "handle": "je_package"
  },
  {
    "id": "jo",
    "iso": "JO",
    "de": "Jordanien",
    "en": "Jordan",
    "region": "naher_osten",
    "flagge": "🇯🇴",
    "beliebt": false,
    "slug": "jordan",
    "such": "Jordan Amman Petra Aqaba JO",
    "handle": "jo_package"
  },
  {
    "id": "kz",
    "iso": "KZ",
    "de": "Kasachstan",
    "en": "Kazakhstan",
    "region": "asien",
    "flagge": "🇰🇿",
    "beliebt": false,
    "slug": "kazakhstan",
    "such": "Kazakhstan Almaty Astana KZ",
    "handle": "kz_package"
  },
  {
    "id": "ke",
    "iso": "KE",
    "de": "Kenia",
    "en": "Kenya",
    "region": "afrika",
    "flagge": "🇰🇪",
    "beliebt": false,
    "slug": "kenya",
    "such": "Kenya Nairobi Mombasa Safari Masai Mara KE",
    "handle": "ke_package"
  },
  {
    "id": "kw",
    "iso": "KW",
    "de": "Kuwait",
    "en": "Kuwait",
    "region": "naher_osten",
    "flagge": "🇰🇼",
    "beliebt": false,
    "slug": "kuwait",
    "such": "Kuwait  KW",
    "handle": "kw_package"
  },
  {
    "id": "kg",
    "iso": "KG",
    "de": "Kirgisistan",
    "en": "Kyrgyzstan",
    "region": "asien",
    "flagge": "🇰🇬",
    "beliebt": false,
    "slug": "kyrgyzstan",
    "such": "Kyrgyzstan Bischkek KG",
    "handle": "kg_package"
  },
  {
    "id": "la",
    "iso": "LA",
    "de": "Laos",
    "en": "Laos",
    "region": "asien",
    "flagge": "🇱🇦",
    "beliebt": false,
    "slug": "laos",
    "such": "Laos Vientiane Luang Prabang LA",
    "handle": "la_package"
  },
  {
    "id": "lv",
    "iso": "LV",
    "de": "Lettland",
    "en": "Latvia",
    "region": "europa",
    "flagge": "🇱🇻",
    "beliebt": false,
    "slug": "latvia",
    "such": "Latvia Riga LV",
    "handle": "lv_package"
  },
  {
    "id": "lr",
    "iso": "LR",
    "de": "Liberia",
    "en": "Liberia",
    "region": "afrika",
    "flagge": "🇱🇷",
    "beliebt": false,
    "slug": "liberia",
    "such": "Liberia Monrovia LR",
    "handle": "lr_package"
  },
  {
    "id": "ly",
    "iso": "LY",
    "de": "Libyen",
    "en": "Libya",
    "region": "afrika",
    "flagge": "🇱🇾",
    "beliebt": false,
    "slug": "libya",
    "such": "Libya Tripolis LY",
    "handle": "ly_package"
  },
  {
    "id": "li",
    "iso": "LI",
    "de": "Liechtenstein",
    "en": "Liechtenstein",
    "region": "europa",
    "flagge": "🇱🇮",
    "beliebt": false,
    "slug": "liechtenstein",
    "such": "Liechtenstein Vaduz LI",
    "handle": "li_package"
  },
  {
    "id": "lt",
    "iso": "LT",
    "de": "Litauen",
    "en": "Lithuania",
    "region": "europa",
    "flagge": "🇱🇹",
    "beliebt": false,
    "slug": "lithuania",
    "such": "Lithuania Vilnius LT",
    "handle": "lt_package"
  },
  {
    "id": "lu",
    "iso": "LU",
    "de": "Luxemburg",
    "en": "Luxembourg",
    "region": "europa",
    "flagge": "🇱🇺",
    "beliebt": false,
    "slug": "luxembourg",
    "such": "Luxembourg  LU",
    "handle": "lu_package"
  },
  {
    "id": "mo",
    "iso": "MO",
    "de": "Macau",
    "en": "Macao",
    "region": "asien",
    "flagge": "🇲🇴",
    "beliebt": false,
    "slug": "macao",
    "such": "Macao Macao MO",
    "handle": "mo_package"
  },
  {
    "id": "mg",
    "iso": "MG",
    "de": "Madagaskar",
    "en": "Madagascar",
    "region": "afrika",
    "flagge": "🇲🇬",
    "beliebt": false,
    "slug": "madagascar",
    "such": "Madagascar Antananarivo MG",
    "handle": "mg_package"
  },
  {
    "id": "mw",
    "iso": "MW",
    "de": "Malawi",
    "en": "Malawi",
    "region": "afrika",
    "flagge": "🇲🇼",
    "beliebt": false,
    "slug": "malawi",
    "such": "Malawi Lilongwe MW",
    "handle": "mw_package"
  },
  {
    "id": "my",
    "iso": "MY",
    "de": "Malaysia",
    "en": "Malaysia",
    "region": "asien",
    "flagge": "🇲🇾",
    "beliebt": true,
    "slug": "malaysia",
    "such": "Malaysia Kuala Lumpur Langkawi Penang MY",
    "handle": "my_package"
  },
  {
    "id": "mv",
    "iso": "MV",
    "de": "Malediven",
    "en": "Maldives",
    "region": "asien",
    "flagge": "🇲🇻",
    "beliebt": true,
    "slug": "maldives",
    "such": "Maldives Male Maldives MV",
    "handle": "mv_package"
  },
  {
    "id": "ml",
    "iso": "ML",
    "de": "Mali",
    "en": "Mali",
    "region": "afrika",
    "flagge": "🇲🇱",
    "beliebt": false,
    "slug": "mali",
    "such": "Mali Bamako ML",
    "handle": "ml_package"
  },
  {
    "id": "mt",
    "iso": "MT",
    "de": "Malta",
    "en": "Malta",
    "region": "europa",
    "flagge": "🇲🇹",
    "beliebt": true,
    "slug": "malta",
    "such": "Malta Valletta Gozo MT",
    "handle": "mt_package"
  },
  {
    "id": "mq",
    "iso": "MQ",
    "de": "Martinique",
    "en": "Martinique",
    "region": "lateinamerika",
    "flagge": "🇲🇶",
    "beliebt": false,
    "slug": "martinique",
    "such": "Martinique  MQ",
    "handle": "mq_package"
  },
  {
    "id": "mr",
    "iso": "MR",
    "de": "Mauretanien",
    "en": "Mauritania",
    "region": "afrika",
    "flagge": "🇲🇷",
    "beliebt": false,
    "slug": "mauritania",
    "such": "Mauritania Nouakchott MR",
    "handle": "mr_package"
  },
  {
    "id": "mu",
    "iso": "MU",
    "de": "Mauritius",
    "en": "Mauritius",
    "region": "afrika",
    "flagge": "🇲🇺",
    "beliebt": true,
    "slug": "mauritius",
    "such": "Mauritius Port Louis MU",
    "handle": "mu_package"
  },
  {
    "id": "yt",
    "iso": "YT",
    "de": "Mayotte",
    "en": "Mayotte",
    "region": "afrika",
    "flagge": "🇾🇹",
    "beliebt": false,
    "slug": "mayotte",
    "such": "Mayotte  YT",
    "handle": "yt_package"
  },
  {
    "id": "mx",
    "iso": "MX",
    "de": "Mexiko",
    "en": "Mexico",
    "region": "nordamerika",
    "flagge": "🇲🇽",
    "beliebt": true,
    "slug": "mexico",
    "such": "Mexico Cancun Tulum Mexiko Stadt Playa del Carmen MX",
    "handle": "mx_package"
  },
  {
    "id": "md",
    "iso": "MD",
    "de": "Moldau",
    "en": "Moldova",
    "region": "europa",
    "flagge": "🇲🇩",
    "beliebt": false,
    "slug": "moldova",
    "such": "Moldova Moldawien Chisinau MD",
    "handle": "md_package"
  },
  {
    "id": "mc",
    "iso": "MC",
    "de": "Monaco",
    "en": "Monaco",
    "region": "europa",
    "flagge": "🇲🇨",
    "beliebt": false,
    "slug": "monaco",
    "such": "Monaco Monte Carlo MC",
    "handle": "mc_package"
  },
  {
    "id": "mn",
    "iso": "MN",
    "de": "Mongolei",
    "en": "Mongolia",
    "region": "asien",
    "flagge": "🇲🇳",
    "beliebt": false,
    "slug": "mongolia",
    "such": "Mongolia Ulaanbaatar MN",
    "handle": "mn_package"
  },
  {
    "id": "me",
    "iso": "ME",
    "de": "Montenegro",
    "en": "Montenegro",
    "region": "europa",
    "flagge": "🇲🇪",
    "beliebt": true,
    "slug": "montenegro",
    "such": "Montenegro Budva Kotor ME",
    "handle": "me_package"
  },
  {
    "id": "ms",
    "iso": "MS",
    "de": "Montserrat",
    "en": "Montserrat",
    "region": "lateinamerika",
    "flagge": "🇲🇸",
    "beliebt": false,
    "slug": "montserrat",
    "such": "Montserrat  MS",
    "handle": "ms_package"
  },
  {
    "id": "ma",
    "iso": "MA",
    "de": "Marokko",
    "en": "Morocco",
    "region": "afrika",
    "flagge": "🇲🇦",
    "beliebt": true,
    "slug": "morocco",
    "such": "Morocco Marrakesch Agadir Casablanca Fes MA",
    "handle": "ma_package"
  },
  {
    "id": "mz",
    "iso": "MZ",
    "de": "Mosambik",
    "en": "Mozambique",
    "region": "afrika",
    "flagge": "🇲🇿",
    "beliebt": false,
    "slug": "mozambique",
    "such": "Mozambique Maputo MZ",
    "handle": "mz_package"
  },
  {
    "id": "np",
    "iso": "NP",
    "de": "Nepal",
    "en": "Nepal",
    "region": "asien",
    "flagge": "🇳🇵",
    "beliebt": false,
    "slug": "nepal",
    "such": "Nepal Kathmandu Pokhara NP",
    "handle": "np_package"
  },
  {
    "id": "nl",
    "iso": "NL",
    "de": "Niederlande",
    "en": "Netherlands",
    "region": "europa",
    "flagge": "🇳🇱",
    "beliebt": true,
    "slug": "netherlands",
    "such": "Netherlands Amsterdam Holland Rotterdam NL",
    "handle": "nl_package"
  },
  {
    "id": "nz",
    "iso": "NZ",
    "de": "Neuseeland",
    "en": "New Zealand",
    "region": "ozeanien",
    "flagge": "🇳🇿",
    "beliebt": true,
    "slug": "new-zealand",
    "such": "New Zealand Auckland Wellington NZ",
    "handle": "nz_package"
  },
  {
    "id": "ni",
    "iso": "NI",
    "de": "Nicaragua",
    "en": "Nicaragua",
    "region": "lateinamerika",
    "flagge": "🇳🇮",
    "beliebt": false,
    "slug": "nicaragua",
    "such": "Nicaragua Managua NI",
    "handle": "ni_package"
  },
  {
    "id": "ne",
    "iso": "NE",
    "de": "Niger",
    "en": "Niger",
    "region": "afrika",
    "flagge": "🇳🇪",
    "beliebt": false,
    "slug": "niger",
    "such": "Niger Niamey NE",
    "handle": "ne_package"
  },
  {
    "id": "ng",
    "iso": "NG",
    "de": "Nigeria",
    "en": "Nigeria",
    "region": "afrika",
    "flagge": "🇳🇬",
    "beliebt": false,
    "slug": "nigeria",
    "such": "Nigeria Lagos Abuja NG",
    "handle": "ng_package"
  },
  {
    "id": "mk",
    "iso": "MK",
    "de": "Nordmazedonien",
    "en": "North Macedonia",
    "region": "europa",
    "flagge": "🇲🇰",
    "beliebt": false,
    "slug": "north-macedonia",
    "such": "North Macedonia Skopje Ohrid Mazedonien MK",
    "handle": "mk_package"
  },
  {
    "id": "no",
    "iso": "NO",
    "de": "Norwegen",
    "en": "Norway",
    "region": "europa",
    "flagge": "🇳🇴",
    "beliebt": true,
    "slug": "norway",
    "such": "Norway Oslo Lofoten Bergen Tromsoe NO",
    "handle": "no_package"
  },
  {
    "id": "om",
    "iso": "OM",
    "de": "Oman",
    "en": "Oman",
    "region": "naher_osten",
    "flagge": "🇴🇲",
    "beliebt": false,
    "slug": "oman",
    "such": "Oman Maskat Muscat Salalah OM",
    "handle": "om_package"
  },
  {
    "id": "pk",
    "iso": "PK",
    "de": "Pakistan",
    "en": "Pakistan",
    "region": "asien",
    "flagge": "🇵🇰",
    "beliebt": false,
    "slug": "pakistan",
    "such": "Pakistan Islamabad Lahore Karatschi PK",
    "handle": "pk_package"
  },
  {
    "id": "pa",
    "iso": "PA",
    "de": "Panama",
    "en": "Panama",
    "region": "lateinamerika",
    "flagge": "🇵🇦",
    "beliebt": false,
    "slug": "panama",
    "such": "Panama Panama Stadt PA",
    "handle": "pa_package"
  },
  {
    "id": "py",
    "iso": "PY",
    "de": "Paraguay",
    "en": "Paraguay",
    "region": "lateinamerika",
    "flagge": "🇵🇾",
    "beliebt": false,
    "slug": "paraguay",
    "such": "Paraguay Asuncion PY",
    "handle": "py_package"
  },
  {
    "id": "pe",
    "iso": "PE",
    "de": "Peru",
    "en": "Peru",
    "region": "lateinamerika",
    "flagge": "🇵🇪",
    "beliebt": false,
    "slug": "peru",
    "such": "Peru Lima Cusco Machu Picchu PE",
    "handle": "pe_package"
  },
  {
    "id": "ph",
    "iso": "PH",
    "de": "Philippinen",
    "en": "Philippines",
    "region": "asien",
    "flagge": "🇵🇭",
    "beliebt": true,
    "slug": "philippines",
    "such": "Philippines Manila Cebu Palawan Boracay PH",
    "handle": "ph_package"
  },
  {
    "id": "pl",
    "iso": "PL",
    "de": "Polen",
    "en": "Poland",
    "region": "europa",
    "flagge": "🇵🇱",
    "beliebt": true,
    "slug": "poland",
    "such": "Poland Warschau Krakau Danzig PL",
    "handle": "pl_package"
  },
  {
    "id": "pt",
    "iso": "PT",
    "de": "Portugal",
    "en": "Portugal",
    "region": "europa",
    "flagge": "🇵🇹",
    "beliebt": true,
    "slug": "portugal",
    "such": "Portugal Lissabon Algarve Madeira Porto PT",
    "handle": "pt_package"
  },
  {
    "id": "pr",
    "iso": "PR",
    "de": "Puerto Rico",
    "en": "Puerto Rico",
    "region": "lateinamerika",
    "flagge": "🇵🇷",
    "beliebt": false,
    "slug": "puerto-rico",
    "such": "Puerto Rico San Juan PR",
    "handle": "pr_package"
  },
  {
    "id": "qa",
    "iso": "QA",
    "de": "Katar",
    "en": "Qatar",
    "region": "naher_osten",
    "flagge": "🇶🇦",
    "beliebt": false,
    "slug": "qatar",
    "such": "Qatar Doha Qatar QA",
    "handle": "qa_package"
  },
  {
    "id": "cg",
    "iso": "CG",
    "de": "Republik Kongo",
    "en": "Republic of the Congo",
    "region": "afrika",
    "flagge": "🇨🇬",
    "beliebt": false,
    "slug": "republic-of-the-congo",
    "such": "Republic of the Congo Brazzaville CG",
    "handle": "cg_package"
  },
  {
    "id": "re",
    "iso": "RE",
    "de": "Réunion",
    "en": "Reunion",
    "region": "afrika",
    "flagge": "🇷🇪",
    "beliebt": false,
    "slug": "reunion",
    "such": "Reunion La Reunion RE",
    "handle": "re_package"
  },
  {
    "id": "ro",
    "iso": "RO",
    "de": "Rumänien",
    "en": "Romania",
    "region": "europa",
    "flagge": "🇷🇴",
    "beliebt": false,
    "slug": "romania",
    "such": "Romania Bukarest Rumaenien Transsilvanien RO",
    "handle": "ro_package"
  },
  {
    "id": "ru",
    "iso": "RU",
    "de": "Russland",
    "en": "Russia",
    "region": "europa",
    "flagge": "🇷🇺",
    "beliebt": false,
    "slug": "russia",
    "such": "Russia Moskau St Petersburg RU",
    "handle": "ru_package"
  },
  {
    "id": "rw",
    "iso": "RW",
    "de": "Ruanda",
    "en": "Rwanda",
    "region": "afrika",
    "flagge": "🇷🇼",
    "beliebt": false,
    "slug": "rwanda",
    "such": "Rwanda Kigali RW",
    "handle": "rw_package"
  },
  {
    "id": "bl",
    "iso": "BL",
    "de": "Saint-Barthélemy",
    "en": "Saint Barthelemy",
    "region": "lateinamerika",
    "flagge": "🇧🇱",
    "beliebt": false,
    "slug": "saint-barthelemy",
    "such": "Saint Barthelemy St Barth BL",
    "handle": "bl_package"
  },
  {
    "id": "kn",
    "iso": "KN",
    "de": "St. Kitts und Nevis",
    "en": "Saint Kitts and Nevis",
    "region": "lateinamerika",
    "flagge": "🇰🇳",
    "beliebt": false,
    "slug": "saint-kitts-and-nevis",
    "such": "Saint Kitts and Nevis Saint Kitts KN",
    "handle": "kn_package"
  },
  {
    "id": "lc",
    "iso": "LC",
    "de": "St. Lucia",
    "en": "Saint Lucia",
    "region": "lateinamerika",
    "flagge": "🇱🇨",
    "beliebt": false,
    "slug": "saint-lucia",
    "such": "Saint Lucia Saint Lucia LC",
    "handle": "lc_package"
  },
  {
    "id": "mf",
    "iso": "MF",
    "de": "Saint-Martin",
    "en": "Saint Martin",
    "region": "lateinamerika",
    "flagge": "🇲🇫",
    "beliebt": false,
    "slug": "saint-martin",
    "such": "Saint Martin St Martin MF",
    "handle": "mf_package"
  },
  {
    "id": "vc",
    "iso": "VC",
    "de": "St. Vincent und die Grenadinen",
    "en": "Saint Vincent and the Grenadines",
    "region": "lateinamerika",
    "flagge": "🇻🇨",
    "beliebt": false,
    "slug": "saint-vincent-and-the-grenadines",
    "such": "Saint Vincent and the Grenadines Saint Vincent VC",
    "handle": "vc_package"
  },
  {
    "id": "ws",
    "iso": "WS",
    "de": "Samoa",
    "en": "Samoa",
    "region": "ozeanien",
    "flagge": "🇼🇸",
    "beliebt": false,
    "slug": "samoa",
    "such": "Samoa Apia WS",
    "handle": "ws_package"
  },
  {
    "id": "sm",
    "iso": "SM",
    "de": "San Marino",
    "en": "San Marino",
    "region": "europa",
    "flagge": "🇸🇲",
    "beliebt": false,
    "slug": "san-marino",
    "such": "San Marino  SM",
    "handle": "sm_package"
  },
  {
    "id": "sa",
    "iso": "SA",
    "de": "Saudi-Arabien",
    "en": "Saudi Arabia",
    "region": "naher_osten",
    "flagge": "🇸🇦",
    "beliebt": true,
    "slug": "saudi-arabia",
    "such": "Saudi Arabia Dschidda Riad Mekka Medina Umrah Dschiddah Jeddah SA",
    "handle": "sa_package"
  },
  {
    "id": "sn",
    "iso": "SN",
    "de": "Senegal",
    "en": "Senegal",
    "region": "afrika",
    "flagge": "🇸🇳",
    "beliebt": false,
    "slug": "senegal",
    "such": "Senegal Dakar SN",
    "handle": "sn_package"
  },
  {
    "id": "rs",
    "iso": "RS",
    "de": "Serbien",
    "en": "Serbia",
    "region": "europa",
    "flagge": "🇷🇸",
    "beliebt": false,
    "slug": "serbia",
    "such": "Serbia Belgrad RS",
    "handle": "rs_package"
  },
  {
    "id": "sc",
    "iso": "SC",
    "de": "Seychellen",
    "en": "Seychelles",
    "region": "afrika",
    "flagge": "🇸🇨",
    "beliebt": true,
    "slug": "seychelles",
    "such": "Seychelles Mahe Praslin SC",
    "handle": "sc_package"
  },
  {
    "id": "sl",
    "iso": "SL",
    "de": "Sierra Leone",
    "en": "Sierra Leone",
    "region": "afrika",
    "flagge": "🇸🇱",
    "beliebt": false,
    "slug": "sierra-leone",
    "such": "Sierra Leone Freetown SL",
    "handle": "sl_package"
  },
  {
    "id": "sg",
    "iso": "SG",
    "de": "Singapur",
    "en": "Singapore",
    "region": "asien",
    "flagge": "🇸🇬",
    "beliebt": true,
    "slug": "singapore",
    "such": "Singapore Singapore SG",
    "handle": "sg_package"
  },
  {
    "id": "sk",
    "iso": "SK",
    "de": "Slowakei",
    "en": "Slovakia",
    "region": "europa",
    "flagge": "🇸🇰",
    "beliebt": false,
    "slug": "slovakia",
    "such": "Slovakia Bratislava SK",
    "handle": "sk_package"
  },
  {
    "id": "si",
    "iso": "SI",
    "de": "Slowenien",
    "en": "Slovenia",
    "region": "europa",
    "flagge": "🇸🇮",
    "beliebt": false,
    "slug": "slovenia",
    "such": "Slovenia Ljubljana Bled SI",
    "handle": "si_package"
  },
  {
    "id": "za",
    "iso": "ZA",
    "de": "Südafrika",
    "en": "South Africa",
    "region": "afrika",
    "flagge": "🇿🇦",
    "beliebt": true,
    "slug": "south-africa",
    "such": "South Africa Kapstadt Johannesburg Suedafrika Kruger ZA",
    "handle": "za_package"
  },
  {
    "id": "kr",
    "iso": "KR",
    "de": "Südkorea",
    "en": "South Korea",
    "region": "asien",
    "flagge": "🇰🇷",
    "beliebt": true,
    "slug": "south-korea",
    "such": "South Korea Seoul Suedkorea Korea KR",
    "handle": "kr_package"
  },
  {
    "id": "es",
    "iso": "ES",
    "de": "Spanien",
    "en": "Spain",
    "region": "europa",
    "flagge": "🇪🇸",
    "beliebt": true,
    "slug": "spain",
    "such": "Spain Mallorca Barcelona Kanaren Ibiza Teneriffa Madrid ES",
    "handle": "es_package"
  },
  {
    "id": "lk",
    "iso": "LK",
    "de": "Sri Lanka",
    "en": "Sri Lanka",
    "region": "asien",
    "flagge": "🇱🇰",
    "beliebt": true,
    "slug": "sri-lanka",
    "such": "Sri Lanka Colombo Kandy LK",
    "handle": "lk_package"
  },
  {
    "id": "sd",
    "iso": "SD",
    "de": "Sudan",
    "en": "Sudan",
    "region": "afrika",
    "flagge": "🇸🇩",
    "beliebt": false,
    "slug": "sudan",
    "such": "Sudan Khartum SD",
    "handle": "sd_package"
  },
  {
    "id": "sr",
    "iso": "SR",
    "de": "Suriname",
    "en": "Suriname",
    "region": "lateinamerika",
    "flagge": "🇸🇷",
    "beliebt": false,
    "slug": "suriname",
    "such": "Suriname Paramaribo SR",
    "handle": "sr_package"
  },
  {
    "id": "se",
    "iso": "SE",
    "de": "Schweden",
    "en": "Sweden",
    "region": "europa",
    "flagge": "🇸🇪",
    "beliebt": false,
    "slug": "sweden",
    "such": "Sweden Stockholm Göteborg SE",
    "handle": "se_package"
  },
  {
    "id": "ch",
    "iso": "CH",
    "de": "Schweiz",
    "en": "Switzerland",
    "region": "europa",
    "flagge": "🇨🇭",
    "beliebt": true,
    "slug": "switzerland",
    "such": "Switzerland Zürich Genf Zermatt Schweiz CH",
    "handle": "ch_package"
  },
  {
    "id": "tj",
    "iso": "TJ",
    "de": "Tadschikistan",
    "en": "Tajikistan",
    "region": "asien",
    "flagge": "🇹🇯",
    "beliebt": false,
    "slug": "tajikistan",
    "such": "Tajikistan Duschanbe TJ",
    "handle": "tj_package"
  },
  {
    "id": "tz",
    "iso": "TZ",
    "de": "Tansania",
    "en": "Tanzania",
    "region": "afrika",
    "flagge": "🇹🇿",
    "beliebt": true,
    "slug": "tanzania",
    "such": "Tanzania Sansibar Zanzibar Daressalam Kilimandscharo TZ",
    "handle": "tz_package"
  },
  {
    "id": "th",
    "iso": "TH",
    "de": "Thailand",
    "en": "Thailand",
    "region": "asien",
    "flagge": "🇹🇭",
    "beliebt": true,
    "slug": "thailand",
    "such": "Thailand Bangkok Phuket Koh Samui Krabi Chiang Mai TH",
    "handle": "th_package"
  },
  {
    "id": "tt",
    "iso": "TT",
    "de": "Trinidad und Tobago",
    "en": "Trinidad and Tobago",
    "region": "lateinamerika",
    "flagge": "🇹🇹",
    "beliebt": false,
    "slug": "trinidad-and-tobago",
    "such": "Trinidad and Tobago Port of Spain TT",
    "handle": "tt_package"
  },
  {
    "id": "tn",
    "iso": "TN",
    "de": "Tunesien",
    "en": "Tunisia",
    "region": "afrika",
    "flagge": "🇹🇳",
    "beliebt": true,
    "slug": "tunisia",
    "such": "Tunisia Tunis Djerba Hammamet Sousse TN",
    "handle": "tn_package"
  },
  {
    "id": "tr",
    "iso": "TR",
    "de": "Türkei",
    "en": "Turkey",
    "region": "europa",
    "flagge": "🇹🇷",
    "beliebt": true,
    "slug": "turkey",
    "such": "Turkey Antalya Istanbul Side Alanya Türkei Turkei Bodrum Kemer TR",
    "handle": "tr_package"
  },
  {
    "id": "tc",
    "iso": "TC",
    "de": "Turks- und Caicosinseln",
    "en": "Turks and Caicos Islands",
    "region": "lateinamerika",
    "flagge": "🇹🇨",
    "beliebt": false,
    "slug": "turks-and-caicos-islands",
    "such": "Turks and Caicos Islands Turks Caicos TC",
    "handle": "tc_package"
  },
  {
    "id": "ug",
    "iso": "UG",
    "de": "Uganda",
    "en": "Uganda",
    "region": "afrika",
    "flagge": "🇺🇬",
    "beliebt": false,
    "slug": "uganda",
    "such": "Uganda Kampala UG",
    "handle": "ug_package"
  },
  {
    "id": "ua",
    "iso": "UA",
    "de": "Ukraine",
    "en": "Ukraine",
    "region": "europa",
    "flagge": "🇺🇦",
    "beliebt": false,
    "slug": "ukraine",
    "such": "Ukraine Kiew Lemberg UA",
    "handle": "ua_package"
  },
  {
    "id": "ae",
    "iso": "AE",
    "de": "Vereinigte Arabische Emirate",
    "en": "United Arab Emirates",
    "region": "naher_osten",
    "flagge": "🇦🇪",
    "beliebt": true,
    "slug": "united-arab-emirates",
    "such": "United Arab Emirates Dubai Abu Dhabi VAE Emirate AE",
    "handle": "ae_package"
  },
  {
    "id": "gb",
    "iso": "GB",
    "de": "Vereinigtes Königreich",
    "en": "United Kingdom",
    "region": "europa",
    "flagge": "🇬🇧",
    "beliebt": true,
    "slug": "united-kingdom",
    "such": "United Kingdom England London Schottland Wales Großbritannien Grossbritannien UK GB",
    "handle": "gb_package"
  },
  {
    "id": "us",
    "iso": "US",
    "de": "Vereinigte Staaten",
    "en": "United States",
    "region": "nordamerika",
    "flagge": "🇺🇸",
    "beliebt": true,
    "slug": "united-states",
    "such": "United States USA New York Florida Kalifornien Las Vegas Amerika Miami US",
    "handle": "us_package"
  },
  {
    "id": "uy",
    "iso": "UY",
    "de": "Uruguay",
    "en": "Uruguay",
    "region": "lateinamerika",
    "flagge": "🇺🇾",
    "beliebt": false,
    "slug": "uruguay",
    "such": "Uruguay Montevideo UY",
    "handle": "uy_package"
  },
  {
    "id": "uz",
    "iso": "UZ",
    "de": "Usbekistan",
    "en": "Uzbekistan",
    "region": "asien",
    "flagge": "🇺🇿",
    "beliebt": false,
    "slug": "uzbekistan",
    "such": "Uzbekistan Taschkent Samarkand Buchara UZ",
    "handle": "uz_package"
  },
  {
    "id": "va",
    "iso": "VA",
    "de": "Vatikanstadt",
    "en": "Vatican City",
    "region": "europa",
    "flagge": "🇻🇦",
    "beliebt": false,
    "slug": "vatican-city",
    "such": "Vatican City Vatikan VA",
    "handle": "va_package"
  },
  {
    "id": "ve",
    "iso": "VE",
    "de": "Venezuela",
    "en": "Venezuela",
    "region": "lateinamerika",
    "flagge": "🇻🇪",
    "beliebt": false,
    "slug": "venezuela",
    "such": "Venezuela Caracas VE",
    "handle": "ve_package"
  },
  {
    "id": "vn",
    "iso": "VN",
    "de": "Vietnam",
    "en": "Vietnam",
    "region": "asien",
    "flagge": "🇻🇳",
    "beliebt": true,
    "slug": "vietnam",
    "such": "Vietnam Hanoi Saigon Ho Chi Minh Da Nang VN",
    "handle": "vn_package"
  },
  {
    "id": "vg",
    "iso": "VG",
    "de": "Britische Jungferninseln",
    "en": "Virgin Islands- British",
    "region": "lateinamerika",
    "flagge": "🇻🇬",
    "beliebt": false,
    "slug": "virgin-islands-british",
    "such": "Virgin Islands- British British Virgin Islands VG",
    "handle": "vg_package"
  },
  {
    "id": "zm",
    "iso": "ZM",
    "de": "Sambia",
    "en": "Zambia",
    "region": "afrika",
    "flagge": "🇿🇲",
    "beliebt": false,
    "slug": "zambia",
    "such": "Zambia Lusaka Victoriafälle ZM",
    "handle": "zm_package"
  },
  {
    "id": "aukus-3",
    "iso": "",
    "de": "AUKUS (3 Länder)",
    "en": "AUKUS(3 countries)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "aukus-3-countries",
    "such": "AUKUS(3 countries) Australien Vereinigtes Königreich USA Mehrländer",
    "handle": "aukus-3_package"
  },
  {
    "id": "af-29",
    "iso": "",
    "de": "Afrika (29 Gebiete)",
    "en": "Africa",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "africa",
    "such": "Africa Afrika Rundreise Mehrländer",
    "handle": "af-29_package"
  },
  {
    "id": "as-12",
    "iso": "",
    "de": "Asien (12 Gebiete)",
    "en": "Asia (12 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "asia-12-areas",
    "such": "Asia (12 areas) Asien Mehrländer",
    "handle": "as-12_package"
  },
  {
    "id": "as-21",
    "iso": "",
    "de": "Asien (20 Gebiete)",
    "en": "Asia (20 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "asia-20-areas",
    "such": "Asia (20 areas) Asien Rundreise Mehrländer",
    "handle": "as-21_package"
  },
  {
    "id": "as-7",
    "iso": "",
    "de": "Asien (7 Gebiete)",
    "en": "Asia (7 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "asia-7-areas",
    "such": "Asia (7 areas) Asien Mehrländer",
    "handle": "as-7_package"
  },
  {
    "id": "as-20",
    "iso": "",
    "de": "Asien (20 Länder)",
    "en": "Asia-20",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "asia-20",
    "such": "Asia-20 Asien Mehrländer",
    "handle": "as-20_package"
  },
  {
    "id": "aunz-2",
    "iso": "",
    "de": "Australien & Neuseeland",
    "en": "Australia & New Zealand",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "australia-new-zealand",
    "such": "Australia & New Zealand Mehrländer Ozeanien",
    "handle": "aunz-2_package"
  },
  {
    "id": "eu-7",
    "iso": "",
    "de": "Balkan (5+ Gebiete)",
    "en": "Balkans (5+ areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "balkans-5-areas",
    "such": "Balkans (5+ areas) Balkan Mehrländer",
    "handle": "eu-7_package"
  },
  {
    "id": "cb-25",
    "iso": "",
    "de": "Karibik (20+ Gebiete)",
    "en": "Caribbean (20+ areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "caribbean-20-areas",
    "such": "Caribbean (20+ areas) Karibik Kreuzfahrt Antillen Mehrländer",
    "handle": "cb-25_package"
  },
  {
    "id": "as-5",
    "iso": "",
    "de": "Zentralasien",
    "en": "Central Asia",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "central-asia",
    "such": "Central Asia Seidenstrasse Mehrländer",
    "handle": "as-5_package"
  },
  {
    "id": "ca-4",
    "iso": "",
    "de": "Zentralasien (4 Gebiete)",
    "en": "Central Asia (4 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "central-asia-4-areas",
    "such": "Central Asia (4 areas) Seidenstrasse Mehrländer",
    "handle": "ca-4_package"
  },
  {
    "id": "cn-3",
    "iso": "",
    "de": "China, Hongkong & Macau",
    "en": "China (mainland HK Macao)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "china-mainland-hk-macao",
    "such": "China (mainland HK Macao) Festland Mehrländer",
    "handle": "cn-3_package"
  },
  {
    "id": "cnjpkr-3",
    "iso": "",
    "de": "China & Japan & Südkorea",
    "en": "China mainland & Japan & South Korea",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "china-mainland-japan-south-korea",
    "such": "China mainland & Japan & South Korea Mehrländer Ostasien",
    "handle": "cnjpkr-3_package"
  },
  {
    "id": "eu-42",
    "iso": "",
    "de": "Europa",
    "en": "Europe",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "europe",
    "such": "Europe Europa EU Mehrländer Roaming",
    "handle": "eu-42_package"
  },
  {
    "id": "eu-33",
    "iso": "",
    "de": "Europa (33 Gebiete)",
    "en": "Europe (33 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "europe-33-areas",
    "such": "Europe (33 areas) Europa EU Mehrländer",
    "handle": "eu-33_package"
  },
  {
    "id": "eu-35",
    "iso": "",
    "de": "Europa (35 Gebiete)",
    "en": "Europe (35 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "europe-35-areas",
    "such": "Europe (35 areas) Europa EU Mehrländer",
    "handle": "eu-35_package"
  },
  {
    "id": "eu-43",
    "iso": "",
    "de": "Europa (40+ Gebiete) & Marokko",
    "en": "Europe (40+ areas) & Morocco",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "europe-40-areas-morocco",
    "such": "Europe (40+ areas) & Morocco Europa Marokko Mehrländer",
    "handle": "eu-43_package"
  },
  {
    "id": "eu-30",
    "iso": "",
    "de": "Europa (30+ Gebiete)",
    "en": "Europe(30+ areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "europe-30-areas",
    "such": "Europe(30+ areas) Europa EU Mehrländer Roaming",
    "handle": "eu-30_package"
  },
  {
    "id": "saaeqakwombh-6",
    "iso": "",
    "de": "Golf-Kooperationsrat (GCC)",
    "en": "GCC",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "gcc",
    "such": "GCC GCC Golfstaaten Mehrländer",
    "handle": "saaeqakwombh-6_package"
  },
  {
    "id": "gl-120",
    "iso": "",
    "de": "Weltweit (120+ Gebiete)",
    "en": "Global (120+ areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "global-120-areas",
    "such": "Global (120+ areas) Global Welt Weltreise Kreuzfahrt Mehrländer",
    "handle": "gl-120_package"
  },
  {
    "id": "gl-139",
    "iso": "",
    "de": "Weltweit (139 Gebiete)",
    "en": "Global139",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "global139",
    "such": "Global139 Global Welt Weltreise Kreuzfahrt Mehrländer",
    "handle": "gl-139_package"
  },
  {
    "id": "me-6",
    "iso": "",
    "de": "Golfregion",
    "en": "Gulf Region",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "gulf-region",
    "such": "Gulf Region Golf Arabische Halbinsel Mehrländer",
    "handle": "me-6_package"
  },
  {
    "id": "iesi-2",
    "iso": "",
    "de": "Irland & Slowenien",
    "en": "Ireland & Slovenia",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "ireland-slovenia",
    "such": "Ireland & Slovenia Mehrländer",
    "handle": "iesi-2_package"
  },
  {
    "id": "bi-2",
    "iso": "",
    "de": "Irland & Vereinigtes Königreich",
    "en": "Ireland & UK",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "ireland-uk",
    "such": "Ireland & UK England Irland Mehrländer",
    "handle": "bi-2_package"
  },
  {
    "id": "jpkr-2",
    "iso": "",
    "de": "Japan & Südkorea",
    "en": "Japan & South Korea",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "japan-south-korea",
    "such": "Japan & South Korea Mehrländer Ostasien",
    "handle": "jpkr-2_package"
  },
  {
    "id": "me-13",
    "iso": "",
    "de": "Naher Osten",
    "en": "Middle East",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "middle-east",
    "such": "Middle East Mehrländer",
    "handle": "me-13_package"
  },
  {
    "id": "me-12",
    "iso": "",
    "de": "Naher Osten & Nordafrika",
    "en": "Middle East & North Africa",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "middle-east-north-africa",
    "such": "Middle East & North Africa MENA Mehrländer",
    "handle": "me-12_package"
  },
  {
    "id": "na-3",
    "iso": "",
    "de": "Nordamerika",
    "en": "North America",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "north-america",
    "such": "North America USA Kanada Mexiko Mehrländer",
    "handle": "na-3_package"
  },
  {
    "id": "sgmyth-3",
    "iso": "",
    "de": "Singapur, Malaysia & Thailand",
    "en": "Singapore & Malaysia & Thailand",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "singapore-malaysia-thailand",
    "such": "Singapore & Malaysia & Thailand Südostasien Mehrländer",
    "handle": "sgmyth-3_package"
  },
  {
    "id": "sa-18",
    "iso": "",
    "de": "Südamerika (18 Gebiete)",
    "en": "South America",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "south-america",
    "such": "South America Suedamerika Mehrländer",
    "handle": "sa-18_package"
  },
  {
    "id": "sa-6",
    "iso": "",
    "de": "Südamerika (6 Gebiete)",
    "en": "South America (6 areas)",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": false,
    "slug": "south-america-6-areas",
    "such": "South America (6 areas) Suedamerika Mehrländer",
    "handle": "sa-6_package"
  },
  {
    "id": "usca-2",
    "iso": "",
    "de": "USA & Kanada",
    "en": "USA & Canada",
    "region": "paket",
    "flagge": "🌍",
    "beliebt": true,
    "slug": "usa-canada",
    "such": "USA & Canada Nordamerika Mehrländer",
    "handle": "usca-2_package"
  }
];
